module.exports = __webpack_public_path__ + "img/728x9O.5928fabe.svg";